import DemoSection from '../DemoSection';
import { UICard } from '../WebComponents';

export default function CardDemo() {
  return (
    <DemoSection title="Card 卡片" description="通用卡片容器">
      <DemoSection.Item title="基础卡片">
        <div className="demo-content">
          <UICard title="卡片标题" subtitle="这是副标题">
            <p>这是卡片内容</p>
          </UICard>
        </div>
        <div className="code-block">
          <code>{`<UICard title="卡片标题" subtitle="这是副标题">
  <p>这是卡片内容</p>
</UICard>`}</code>
        </div>
      </DemoSection.Item>

      <DemoSection.Item title="交互式卡片">
        <div className="demo-content">
          <UICard
            title="可点击卡片"
            subtitle="点击试试"
            interactive
            onUiCardClick={() => alert('卡片被点击')}
          >
            <p>这是一个可交互的卡片</p>
          </UICard>
        </div>
        <div className="code-block">
          <code>{`<UICard
  title="可点击卡片"
  subtitle="点击试试"
  interactive
  onUiCardClick={() => alert('卡片被点击')}
>
  <p>这是一个可交互的卡片</p>
</UICard>`}</code>
        </div>
      </DemoSection.Item>

      <DemoSection.Item title="玻璃效果">
        <div className="demo-content">
          <UICard title="玻璃卡片" glass>
            <p>带有玻璃效果的卡片</p>
          </UICard>
        </div>
        <div className="code-block">
          <code>{`<UICard title="玻璃卡片" glass>
  <p>带有玻璃效果的卡片</p>
</UICard>`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
